import { useMemo } from 'react';
import debounce from '../../../Utils/debouncer.js';

function useDebouncedValueChange(onChangeText, onChangeValue) {
    return useMemo(() => {
        const handleValueChangeDebounced = debounce((textValue, evt) => onChangeValue(textValue, evt), 200);
        return (textValue, evt) => {
            onChangeText(textValue, evt);
            handleValueChangeDebounced(textValue, evt);
        };
    }, [onChangeText, onChangeValue]);
}

export { useDebouncedValueChange as default };
